import { app } from '../app.module'
app
  /**
   * abbreviate 指定文字数より多い場合に省略
   * @param  text 入力値
   * @param  length 出力する文字数
   */
  .filter('abbreviate', () => {
    return function (text: string, length: number) {
      // デフォルトは20文字
      if (isNaN(length)) {
        length = 20
      }
      // 指定文字数以内かチェック
      if (text.length <= length) {
        return text
      } else {
        return String(text).substring(0, length)
      }
    }
  })
